import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { Select } from 'antd';
import * as S from './styles';
import * as Style from 'components/Style';

export const ComponentInputSelectMultiple = ({
  label,
  name,
  control,
  placeholder,
  options,
  disabled,
  errors,
  initialValue = [],
  viewChange = () => {},
  viewDeselect = () => {},
  maxTagCount = null,
  ...rest
}) => {
  const { Option } = Select;

  const [value, setValue] = useState([...initialValue]);

  useEffect(() => {
    if (initialValue.length === 0) setValue([]);
  }, [initialValue]);

  const onSelect = e => {
    viewChange([...value, e]);
    setValue([...value, e]);
  };

  const onDeselect = e => {
    const index = value.indexOf(e);
    if (index > -1) {
      const newList = value.filter(value => value !== e);
      setValue(newList);
      viewDeselect(newList);
    } else {
      setValue([...e]);
    }
  };

  const onClear = () => {
    viewChange([]);
    setValue([]);
  };

  return (
    <S.SelectContain id="ComponenteInputSelect">
      {label && <S.Label>{label}</S.Label>}
      <Controller
        name={name}
        control={control}
        defaultValue={initialValue}
        render={({ field }) => (
          <>
            <Select
              {...field}
              {...rest}
              disabled={disabled}
              mode="multiple"
              allowClear
              showSearch
              optionFilterProp={'children'}
              filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              showArrow
              onClear={onClear}
              value={value}
              style={{ width: '100%' }}
              onSelect={e => onSelect(e)}
              onDeselect={e => onDeselect(e)}
              data-testid="InputSelectMultiple"
              placeholder={placeholder}
              dropdownStyle={{ zIndex: 1 }}
              maxTagCount={maxTagCount}
            >
              {options?.map(item => {
                return (
                  <Option key={`${item?.value}-${item?.label}`} value={item?.value}>
                    {item?.label}
                  </Option>
                );
              })}
            </Select>
            {errors && errors[name] && <Style.GlobalErro>{errors[name]?.message}</Style.GlobalErro>}
          </>
        )}
      />
    </S.SelectContain>
  );
};

ComponentInputSelectMultiple.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  control: PropTypes.object,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  viewChange: PropTypes.func,
  viewDeselect: PropTypes.func,
};

ComponentInputSelectMultiple.defaultProps = {
  // label: null,
  // name: null,
  // control: {},
  // placeholder: null,
  // defaultValue: [],
  // options: [],
  // disabled: false,
  // errors: {},
  // viewChange: () => {},
};

export default ComponentInputSelectMultiple;
